export function randomUid() {
    return Math.random().toString(36).slice(-5)
}

export function removeHtmlTags(html) {
    if (!html) return "";
    return html.replace(/<[^>]+>|\n|\r/g, '').replace(/&nbsp;/g, ' ')
}

export function cleanupTelephone(telephone) {
    if (!telephone) return '';
    return telephone.replace(/\(0\)/, '').replace(/[\.\-\s]/g, '')
}

export function jsonToQueryString (params) {
    if(typeof params !== 'object') {
        return null
    }

    if(!params) {
        return null
    }

    if(!Object.keys(params)?.length) {
        return null
    }

    return `?${Object.keys(params).map(key => key + '=' + params[key]).join('&')}`
}
